import { setLogger } from '../core';
import { logger } from './logger';
setLogger(logger);